import { useState } from 'react';
import { walletsNFTWithdraw } from '../../../../helpers/helperFunctions';
import {
  ArrowPolygon,
  Flexed,
  Select
} from '../../../../styles/GlobalComponents';
import { color } from '../../../../styles/GlobalStyles';
import {
  Icon,
  IconSettingsCheckboxOff,
  IconSettingsCheckboxOn
} from '../../../../styles/Icons';
import { SectionSeparator } from '../../../../styles/stylesStyled';
import { WalletNFTType, WalletsNFTType } from '../../../../types/types';
import { CollapsibleAbsolute, SelectDropDown } from './SelectWallet.styles';
import { useDisconnect } from 'wagmi';

interface SelectWalletProps {
  onChange: (network: WalletsNFTType) => void;
  value: WalletsNFTType | null;
  disabled?: boolean;
  setWalletAddress: any;
  setWalletAddressSign: any;
  setCheckbox1: any;
  setCheckbox2: any;
  setCheckbox3: any;
  setCheckbox4: any;
  setCheckbox5: any;
  setCheckbox6: any;
  setCheckbox7: any;
}

export const SelectWallet = ({
  onChange,
  value,
  disabled,
  setWalletAddress,
  setWalletAddressSign,
  setCheckbox1,
  setCheckbox2,
  setCheckbox3,
  setCheckbox4,
  setCheckbox5,
  setCheckbox6,
  setCheckbox7
}: SelectWalletProps) => {
  const [isOpenDropdown, setIsOpenDropdown] = useState(false);
  const { disconnect } = useDisconnect();

  return (
    <Select
      disabled
      isOpen={isOpenDropdown}
      onClick={() => setIsOpenDropdown(!isOpenDropdown)}>
      <span>
        {value ? (
          <Flexed center>
            <img src={value?.icon} alt='checked' style={{ width: '23px' }} />
            <span>{value?.wallet}</span>
          </Flexed>
        ) : (
          <div style={{ color: color.colors.neutral700 }}>
            Select Blockchain
          </div>
        )}
      </span>

      {!disabled && (
        <>
          <ArrowPolygon
            direction={isOpenDropdown ? 'down' : 'right'}
            customColor={color.colors.neutral700}
          />
          <CollapsibleAbsolute isOpen={isOpenDropdown}>
            <SelectDropDown>
              {walletsNFTWithdraw.map((wallet, index) => (
                <div key={index}>
                  <Flexed
                    between
                    onClick={() => {
                      onChange(wallet);

                      setCheckbox1(false);
                      setCheckbox2(false);
                      setCheckbox3(false);
                      setCheckbox4(false);
                      setCheckbox5(false);
                      setCheckbox6(false);
                      setCheckbox7(false);

                      setIsOpenDropdown(!isOpenDropdown);

                      if (value?.type === WalletNFTType.FLIPME) {
                        disconnect();
                      }
                    }}
                    key={index}
                    style={{ width: '100%' }}>
                    <Flexed center>
                      <img
                        src={wallet.icon}
                        alt='checked'
                        style={{ marginRight: 10, width: 23 }}
                      />
                      <span>{wallet.wallet}</span>
                    </Flexed>

                    <Icon color={color.colors.secondary100}>
                      {value?.index === index ? (
                        <IconSettingsCheckboxOn size={'24'} />
                      ) : (
                        <IconSettingsCheckboxOff size={'24'} />
                      )}
                    </Icon>
                  </Flexed>
                  <SectionSeparator margin='0' />
                </div>
              ))}
            </SelectDropDown>
          </CollapsibleAbsolute>
        </>
      )}
    </Select>
  );
};
